import { Stack, Typography } from "@mui/material";

interface Props {
  title: string;
  subtitle: string;
}

const ApprovalConfigurationTitle = ({ title, subtitle }: Props) => (
  <Stack spacing={0.5}>
    <Typography variant="h6">{title}</Typography>
    <Typography variant="caption" color="textSecondary">
      {subtitle}
    </Typography>
  </Stack>
);

export default ApprovalConfigurationTitle;
